import { render, staticRenderFns } from "./StructureCompanyAddAndLinkWorkRoleModal.vue?vue&type=template&id=1b149f1e&scoped=true&"
import script from "./StructureCompanyAddAndLinkWorkRoleModal.vue?vue&type=script&lang=js&"
export * from "./StructureCompanyAddAndLinkWorkRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./StructureCompanyAddAndLinkWorkRoleModal.vue?vue&type=style&index=0&id=1b149f1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b149f1e",
  null
  
)

export default component.exports